import React from "react";
import CommingSoon from "./CommingSoon.js";

const Portfolio = (props) => {
  return <CommingSoon title="Portfolio" />;
};

export default Portfolio;
